<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی لیست مشاوران</span>
                </v-tooltip>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="relatedModal"
                                v-model="relatedModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>ویرایش مشاور</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="relatedModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <new-agent :reload="reloadTable" :modal="()=>{relatedModal=false}" v-if="relatedModal"
                                           :data="values"></new-agent>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!--      end edit mode -->

                <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow
                >
                    <v-tab v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card v-if="tab === 0" :loading="loading" class="p-3 pt-0">

                            <terminal-table class="col-12" :currentPage="datas.current_page"
                                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                            :pageCount="datas.last_page"
                                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                            <data-table
                                    v-else
                                    :data="datas"
                                    :columns="columns"
                                    :debounce-delay="3000"
                                    :pagination="paginate"
                                    :orderBy="tableProps.column"
                                    :orderDir="tableProps.dir"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100, 500]"
                                    @on-table-props-changed="reloadTable"
                                    class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                            ></data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <new-agent v-if="tab === 1" :edit="true" :reload="()=>{reloadTable(url)}"
                                   :tab="()=>{tab=0}"></new-agent>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-app>
    </div>
</template>

<script>
import button from "../../button";
import {dataTableProps} from "../../../../main";
import {debounce} from "../../../../custom";
import NewAgent from "./newAgent";

export default {
    name: "list",
    components: {NewAgent},
    data() {
        return {
            tab: "",
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'نام کاربر ',
                    name: 'user',
                    primary: true,
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شهر',
                    name: 'city',
                    transform: (val) => {
                        const cities =  val.data.city.map((x) => {
                           return this.translator("city_" + x)
                        })
                        return `<span title="${cities.join(',')}">${cities.length > 1 ? cities[0]+ ',' +cities[1] + ', ...' : cities[0] }</span>`

                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'دسته بندی',
                    name: 'category',
                    transform: (val) => {
                        return val.data.category === 'real_estate' ? 'املاک' : this.translator(val.data.category);
                    },
                    orderable: true,
                    searchable: true,
                },

                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                            },
                            {
                                name: 'edit',
                                label: 'ویرایش اطلاعات',
                                icon: 'edit',
                                class: 'btn-outline-warning',
                                action: this.actions,
                            },

                        ]
                    }
                },
            ],
            values: [],
            TabsName: [{name: 'لیست مشاوران ', value: 'list'}, {name: 'ثبت مشاور جدید', value: 'newCustomer'}],
            authModal: false,
            loading: false,
            adsModal: false,
            relatedModal: false,
            showMore: false,
            related_id: null,
            datas: {},
            mine: [],
            myRes: [],
            activeComponent: '',
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/agents`,
            selectedNumber: [],
            translates: [],
            dataId: '',
            adsList: '',
        }
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },
    methods: {
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;
            vm.loading = true;
            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این مشاور اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/agents/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        editAction: function (data) {
            this.relatedModal = true;
            this.values = {
                category: data.category,
                city: data.city,
                id: data.id,
                neighborhood: data.neighborhood,
            }
        },
        showAction: function (data) {
            this.showMore = true;
            this.related_id = data.id
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
    },
    watch: {
        tab: function (val) {
            if (val === 0) {
                this.reloadTable();
            }
        }
    },
    mounted() {
        if (localStorage.getItem('localization')) {
            this.translates = JSON.parse(localStorage.getItem('localization'));
            return;
        } else {
            this.getLocalization();
        }
        this.getDataForTable(this.url);
    }
}
</script>

<style scoped>

</style>